import { canFold } from '@/domain/product/canFold';
import { CardStrategy } from '@/infrastructure/engine3d/strategies/CardStrategy';
import { EProductCategory } from '@/domain/product/EProductCategory';
import { GobeletStrategy } from '@/infrastructure/engine3d/strategies/GobeletStrategy';
import type { IFoldableStrategy } from '@/application/ports/IFoldableStrategy';
import type { IProduct3DStrategy } from '@/infrastructure/engine3d/strategies/IProduct3DStrategy';
import type { TProductMeshParams } from '@/application/ports/TProductMeshParams';

type TPickProduct3DStrategyParams = {
    getMaxAnisotropy: () => number;
};

// Capabilities are granted by the domain rule, not guessed from the category.
type TProduct3DStrategySelection = {
    foldable?: IFoldableStrategy;
    strategy: IProduct3DStrategy;
};

// Mesh params → strategy factory. The single mapping point: adding a product category means a
// variant in TProductMeshParams, a case here and a strategy class. The params carry their own
// category, so there is one source for it and the switch narrows them for the constructor.
function pickProduct3DStrategy(meshParams: TProductMeshParams, params: TPickProduct3DStrategyParams): TProduct3DStrategySelection {
    switch (meshParams.category) {
        case EProductCategory.Card: {
            const card = new CardStrategy(meshParams);

            return { foldable: canFold(meshParams.cardForm) ? card : undefined, strategy: card };
        }
        case EProductCategory.Glass:
            return { strategy: new GobeletStrategy({ getMaxAnisotropy: params.getMaxAnisotropy, meshParams }) };
        default: {
            const exhaustive: never = meshParams;
            throw new Error(`pickProduct3DStrategy: unknown category ${String(exhaustive)}`);
        }
    }
}

export { pickProduct3DStrategy };
